import axiosInstance from "@/services/axiosInterceptor";

export async function getRoomStatusById(id, type = "normal") {
  try {
    const response = await axiosInstance.get(
      type === "normal"
        ? `common/booked-session/${id}/room-status`
        : `common/scheduled-session/${id}/room-status`,
      {
        byPassLoader: true,
      }
    );
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
